<div class="modal-header">
  <div class="w-100 d-flex align-items-center justify-content-between">
    <h5 class="mb-1">
      <strong>{{ 'map.sidebar.psa.check_list.title' | translate }}</strong> - {{ PSAentity?.search_term }}
    </h5>
    <button mat-icon-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-accordion class="w-100 element-detail" *ngIf="PSAentity">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <strong>Dettaglio</strong>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="wrapper-element-detail">
        <app-psa-element-detail
          [data]="[{ key: 'urn', value: PSAentity.urn }]"
          [isDialog]="false"
          [isPSAEnabled]="false"
          (detailRequested)="addDetailFromFeature($event)"
        >
        </app-psa-element-detail>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="checklist-title" *ngIf="checklistTitle">{{ checklistTitle }}</div>

  <div class="checklist-actions" *ngIf="checkListSection?.length > 0">
    <button mat-stroked-button color="primary" (click)="exportChecklist('excel', false)">
      <mat-icon>download</mat-icon>
      {{ 'map.sidebar.psa.actions.download' | translate }} excel
    </button>
    <button mat-stroked-button color="primary" (click)="exportChecklist('pdf', false)">
      <mat-icon>download</mat-icon>
      {{ 'map.sidebar.psa.actions.download' | translate }} pdf
    </button>
    <button mat-stroked-button color="primary" (click)="exportChecklist('pdf', true)">
      <mat-icon>inventory</mat-icon>
      {{ 'map.sidebar.psa.actions.checklist.download_filesystem' | translate }}
    </button>
    <button mat-stroked-button color="primary" [disabled]="!PSAentity" (click)="duplicate()">
      <mat-icon>content_copy</mat-icon>
      {{ 'map.sidebar.psa.actions.checklist.duplicate' | translate }}
    </button>
  </div>
</div>

<div class="modal-body">
  <div class="container-fluid scrollable-div" *ngIf="checkListSection">
    <div class="row" *ngIf="checkListSection.length === 0">
      <h5 class="text-center mt-4">{{ 'map.sidebar.psa.check_list.no_items' | translate }}</h5>
    </div>

    <!-- Iterazione sui gruppi -->
    <div class="row" *ngIf="groupList && checkListSection">
      <div *ngFor="let group of groupList">
        <div
          class="my-2 py-1 px-1 d-flex align-items-center justify-content-between pointer hover"
          (click)="group.expanded = !group.expanded"
        >
          <!-- Nome del gruppo -->
          <h6 class="pt-2">
            {{ group?.title | uppercase }}
          </h6>
          <mat-icon>{{ group.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>

        <!-- Sotto-blocchi della sezione (solo TRATTAMENTO ne ha piu' di uno, gli altri template hanno sottotitolo vuoto) -->
        <div *ngIf="group.expanded">
          <div *ngFor="let section of group.sections">
            <h6 class="subsection-title" *ngIf="section.title">{{ section.title }}</h6>

            <!-- Voci, ciascuna a tendina e chiusa all'apertura -->
            <mat-accordion multi>
              <mat-expansion-panel
                *ngFor="
                  let field of checklistItemDividedBySectionAndGroup(section.title, group.title)
                    | filterAndTransform : section : parseStringToArray
                "
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="py-2 d-flex align-items-center justify-content-start gap-3 w-100">
                      <mat-icon *ngIf="!isFieldDaCompletare(field)"></mat-icon>
                      <mat-icon
                        *ngIf="isFieldDaCompletare(field)"
                        color="warn"
                        matTooltip="{{ 'map.sidebar.psa.risk_event.value_not_entered' | translate }}"
                        >brightness_1</mat-icon
                      >
                      <strong>
                        {{ field.description_title }}
                      </strong>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="indicazione" *ngIf="field.indicazione">
                  <mat-icon>info_outline</mat-icon>
                  <span>{{ field.indicazione }}</span>
                </div>

                <!-- Campi della checklist -->
                <div class="row">
                  <div class="col-11">
                    <mat-form-field appearance="fill" class="w-100" *ngIf="field && field.field_type === 'text'">
                      <mat-label>{{ field.field_name }}</mat-label>
                      <input
                        matInput
                        class="w-100"
                        [(ngModel)]="field.field_value"
                        type="text"
                        [placeholder]="textPlaceholder(field.field_name)"
                        [errorStateMatcher]="textMatcher(field.field_name)"
                      />
                      <!-- the calendar writes dd/mm/yyyy into the text field: typed dates are validated as text,
                           so the native date adapter never parses them with another day/month order -->
                      <!-- trigger and menu in the same view, so the menu can reference the trigger to close itself -->
                      <ng-container *ngIf="isDateField(field.field_name)" ngProjectAs="[matSuffix]">
                        <button
                          mat-icon-button
                          matSuffix
                          type="button"
                          [matMenuTriggerFor]="calendarMenu"
                          #calendarTrigger="matMenuTrigger"
                        >
                          <mat-icon>calendar_today</mat-icon>
                        </button>
                        <mat-menu #calendarMenu="matMenu" class="checklist-calendar-menu">
                          <div (click)="$event.stopPropagation()">
                            <mat-calendar
                              [maxDate]="today"
                              (selectedChange)="onDatePicked(field, $event); calendarTrigger.closeMenu()"
                            ></mat-calendar>
                          </div>
                        </mat-menu>
                      </ng-container>
                      <mat-hint *ngIf="isCoordinatesField(field.field_name)">
                        Lat/Lon in gradi (es. 45.6983, 9.6773) oppure E/N in metri (es. X: 571330 Y: 5074175)
                      </mat-hint>
                    </mat-form-field>

                    <mat-form-field
                      appearance="fill"
                      class="w-100"
                      *ngIf="field && field.field_type === 'number'"
                    >
                      <mat-label>{{ field.field_name }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="field.field_value"
                        type="number"
                        min="0"
                        [errorStateMatcher]="numberMatcher(field.field_name)"
                      />
                      <mat-hint class="text-danger" *ngIf="!isNumberAllowed(field.field_name, field.field_value)">
                        {{ numberRuleKey(field.field_name) | translate }}
                      </mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="w-100" *ngIf="field && field.field_type === 'enumerator'">
                      <mat-label>{{ field.field_name }}</mat-label>
                      <mat-select [(ngModel)]="field.field_value">
                        <mat-option *ngFor="let option of field.field_options" [value]="option">
                          {{ option }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div class="w-100" *ngIf="field && field.field_type === 'radio'">
                      <mat-radio-group [(ngModel)]="field.field_value" aria-label="Select an option">
                        <mat-radio-button *ngFor="let option of field.field_options" [value]="option">
                          {{ option }}
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>

                    <div
                      class="w-100"
                      *ngIf="
                        field && field.field_type === 'check' && field.field_options && field.field_options.length > 0
                      "
                    >
                      <div *ngFor="let option of field.field_options; let i = index">
                        <mat-checkbox
                          [checked]="isChecked(option, field)"
                          (change)="onCheckboxChange($event, option, field)"
                        >
                          {{ option }}
                        </mat-checkbox>
                      </div>
                    </div>

                    <div class="w-100" *ngIf="field && field.field_type === 'parametri'">
                      <div class="parametro" *ngFor="let parametro of field.field_options">
                        <mat-checkbox
                          [checked]="isOpzioneSelezionata(field, parametro)"
                          (change)="onParametroChange($event, parametro, field)"
                        >
                          {{ parametro }}
                        </mat-checkbox>
                        <mat-radio-group
                          class="modalita"
                          *ngIf="parametro !== parametroNessuno && isOpzioneSelezionata(field, parametro)"
                          [(ngModel)]="field.field_value[parametro]"
                        >
                          <mat-radio-button *ngFor="let modalita of field.field_modalita" [value]="modalita">
                            {{ modalita }}
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>

                    <div class="w-100" *ngIf="field && field.field_type === 'dettagli'">
                      <div *ngFor="let opzione of field.field_options">
                        <mat-checkbox
                          [checked]="isOpzioneSelezionata(field, opzione)"
                          (change)="onDettaglioChange($event, opzione, field)"
                        >
                          {{ opzione }}
                        </mat-checkbox>
                        <div class="campi-dettaglio" *ngIf="isOpzioneSelezionata(field, opzione)">
                          <mat-form-field
                            appearance="fill"
                            *ngFor="let campo of field.field_campi"
                          >
                            <mat-label>{{ campo }}</mat-label>
                            <input
                              *ngIf="field.field_campi_type === 'text'; else campoNumerico"
                              matInput
                              type="text"
                              [(ngModel)]="field.field_value[opzione][campo]"
                            />
                            <ng-template #campoNumerico>
                              <input
                                matInput
                                type="number"
                                min="0"
                                [max]="campo === '%' ? 100 : null"
                                [errorStateMatcher]="numberMatcher(campo)"
                                [(ngModel)]="field.field_value[opzione][campo]"
                              />
                            </ng-template>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>

                    <div class="w-100" *ngIf="field && field.field_type === 'sottolivelli'">
                      <!-- i sottolivelli si aprono subito sotto l'opzione scelta; niente mat-radio-group
                           esterno: includerebbe anche i radio dei sottolivelli -->
                      <div class="risposte-con-sottolivelli">
                        <ng-container *ngFor="let risposta of field.field_options">
                          <mat-radio-button
                            [name]="'risposta-' + field.id"
                            [value]="risposta"
                            [checked]="field.field_value?.risposta === risposta"
                            (change)="onRispostaChange(risposta, field)"
                          >
                            {{ risposta }}
                          </mat-radio-button>

                          <ng-container *ngIf="field.field_value?.risposta === risposta">
                            <div class="sottolivello" *ngFor="let sottolivello of sottolivelliDellaRisposta(field)">
                              <div class="sottolivello-titolo">{{ sottolivello.titolo }}</div>
                              <mat-radio-group
                                class="sottolivello-opzioni"
                                *ngIf="sottolivello.tipo === 'radio'"
                                [(ngModel)]="field.field_value.sottolivelli[sottolivello.titolo]"
                              >
                                <mat-radio-button *ngFor="let opzione of sottolivello.opzioni" [value]="opzione">
                                  {{ sottolivello.etichette?.[opzione] ?? opzione }}
                                </mat-radio-button>
                              </mat-radio-group>
                              <div class="sottolivello-opzioni" *ngIf="sottolivello.tipo === 'check'">
                                <mat-checkbox
                                  *ngFor="let opzione of sottolivello.opzioni"
                                  [checked]="isSottolivelloChecked(field, sottolivello, opzione)"
                                  (change)="onSottolivelloCheckChange($event, field, sottolivello, opzione)"
                                >
                                  {{ sottolivello.etichette?.[opzione] ?? opzione }}
                                </mat-checkbox>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="col-1 mt-2">
                    <button
                      mat-icon-button
                      (click)="field.field_value = null"
                      matTooltip="{{ 'map.sidebar.psa.risk_event.delete_value' | translate }}"
                    >
                      <mat-icon>clear</mat-icon>
                    </button>
                  </div>
                </div>

                <!-- an item that is itself the "Note" row of the ministerial template already has its own text field -->
                <div class="d-flex flex-column justify-content-between pl-3" *ngIf="!isNotesItem(field)">
                  <div class="etichetta-note" *ngIf="field.etichetta_note">{{ field.etichetta_note }}</div>
                  <mat-form-field>
                    <mat-label>Note</mat-label>
                    <textarea
                      matInput
                      class="w-100"
                      [(ngModel)]="field.note"
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="10"
                    ></textarea>
                  </mat-form-field>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="d-flex justify-content-end align-items-center mt-3 gap-3">
  <button mat-button (click)="onCancel()">
    {{ 'map.sidebar.psa.risk_event.button_cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="hasInvalidValues" (click)="onConfirm()">
    {{ 'map.sidebar.psa.risk_event.button_save' | translate }}
  </button>
</div>
